<template>
  <div class="uk-container uk-container-expand">
    <div class="uk-grid uk-child-width-1-1 uk-grid-small">
      <div>
        <div class="uk-flex uk-flex-between uk-flex-middle">
          <div>
            <h3 class="uk-h3 uk-margin-remove">
              <span data-uk-icon="icon: commenting;ratio: 1.5"></span> {{ headerLabel }}
            </h3>
          </div>
          <div>
            <router-link :to="{name: 'press'}" class="uk-margin-right uk-button uk-button-text">
              abbrechen
            </router-link>
            <div class="uk-button-group">
              <button
                class="uk-button uk-button-primary"
                @click.prevent="store"
                :disabled="submitting"
              >Speichern</button>
              <div class="uk-inline">
                <button class="uk-button uk-button-primary" type="button" :disabled="submitting">
                  <span uk-icon="icon: triangle-down"></span>
                </button>
                <div
                  ref="storeDropdown"
                  uk-dropdown="animation: uk-animation-slide-top-small; duration: 200;delay-hide: 0;mode: click; boundary: ! .uk-button-group; boundary-align: true;pos: bottom-right"
                >
                  <ul class="uk-nav uk-dropdown-nav">
                    <li>
                      <a href="#" @click.prevent="storeAndClose">Speichern und Schließen</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="uk-form-stacked uk-margin-top uk-margin-large-bottom">
        <div class="uk-grid" data-uk-grid>
            <div class="uk-width-3-4">
              <div class="uk-card uk-card-default uk-card-small uk-card-body">
                <div class="uk-margin">
                  <label class="uk-form-label">Titel</label>
                  <input class="uk-input" :class="{'uk-form-danger': formErrors['title']}" type="text" placeholder="Titel" v-model="release.title">
                </div>
                <div class="uk-margin">
                  <label class="uk-form-label">Text</label>
                  <editor :init="initEditor" :id="'release-' + release.id" v-model="release.body"></editor>
                </div>
                <div class="uk-margin">
                  <label class="uk-form-label">Link</label>
                  <input class="uk-input" type="text" v-model="release.data.link">
                </div>
              </div>
            </div>
            <div class="uk-width-1-4">
              <div class="uk-card uk-card-default uk-card-small">
                <div class="uk-card-body">
                  <form class="uk-form-stacked">
                      <div class="uk-margin">
                        <label class="uk-form-label">Bild</label>
                        <div class="uk-form-controls">
                          <select-image :source="release.data.image.src" @image-selected="onImageSelected" @image-removed="onImageRemoved" />
                          <input type="text" class="uk-input" placeholder="Alt Text" v-model="release.data.image.alt">
                        </div>
                      </div>
                      <hr>
                      <div class="uk-margin">
                        <label class="uk-form-label">Logo</label>
                        <div class="uk-form-controls">
                          <select-image :source="release.data.logo.src" @image-selected="onLogoSelected" @image-removed="onLogoRemoved" />
                          <input type="text" class="uk-input" placeholder="Alt Text" v-model="release.data.logo.alt">
                        </div>
                      </div>
                      <div class="uk-margin">
                        <label class="uk-form-label">Veröffentlicht am</label>
                        <date-picker
                          :attributes="datepickerAttr"
                          :input-props='{class: "uk-input"}'
                          :popover="{ visibility: 'click' }"
                          locale="de"
                          v-model="publishedDate"
                        />
                      </div>
                      <div class="uk-margin">
                          <div class="uk-form-label">Status</div>
                          <label class="uk-switch">
                            <input type="checkbox" v-model="release.active">
                            <div class="uk-switch-slider uk-switch-on-off round"></div>
                          </label>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import PageService from "@/services/page.service";
import "izitoast/dist/css/iziToast.min.css";
import iziToast from "izitoast/dist/js/iziToast.min.js";
//import Editor from "@/components/Editor";
import tinymce from 'tinymce/tinymce';
import 'tinymce/themes/silver/theme'
import 'tinymce/plugins/paste';
import 'tinymce/plugins/link';
import 'tinymce/plugins/code';
import 'tinymce/plugins/image';
import "tinymce/plugins/pagebreak";
import "tinymce/plugins/autoresize";
//import 'tinymce/plugins/preview';
import Editor from '@tinymce/tinymce-vue';

import Upload from "@/components/Upload";
import SelectImage from '@/components/finder/SelectImage'
import DatePicker from 'v-calendar/lib/components/date-picker.umd'
import moment from 'moment';
export default {
  components: {
    vSelect,
    Editor,
    Upload,
    SelectImage,
    DatePicker
  },
  data() {
    return {
      releaseId: this.$route.params.id,
      submitting: false,
      datepickerAttr: [{
        key: 'today',
        dot: true,
        dates: new Date(),
      }],
      release: {
        id: null,
        active: false,
        title: '',
        data: {
          link: '',
          image: {
            id: null,
            src:'',
            alt: '',
          },
          logo: {
            id: null,
            src:'',
            alt: '',
          },
        }
      },
      formErrors: {},
      closeAfterSave: false,
      initEditor: {
        menubar: false,
        branding: false,
        pagebreak_split_block: true,
        relative_urls: false,
        document_base_url: '/',
        min_height: 425,
        max_height: 800,
        toolbar: 'styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent paste | link neqstImage | pagebreak code',
        plugins: 'code link pagebreak autoresize paste',
        autoresize_bottom_margin: 50,
        language_url: `/tinymce/langs/de.js`,
        language: 'de',
        skin_url: '/tinymce/skins/ui/oxide',
        content_css : '/tinymce/skins/content/default/content.min.css',
        external_plugins: {
          'neqstImage': '/tinymce/plugins/image-picker/plugin.js'
        },
      }
    };
  },
  mounted() {
    if(this.releaseId) {
      this.getRelease();
    }
  },
  computed: {
    headerLabel() {
      return 'Pressemeldung ' + (this.releaseId ? 'bearbeiten' : 'erstellen')
    },
    publishedDate: {
      get() {
        return this.release.publishedAt ? new Date(this.release.publishedAt) : new Date()
      },
      set(value) {
        this.release.publishedAt = moment(value).format('YYYY-MM-DD')
      }
    }
  },
  methods: {
    async getRelease() {
      let release = await PageService.getPressRelease(this.releaseId);

      this.release = _.assign({}, this.release, release.data);
    },
    store() {
      this.submitting = true;

      PageService.storePressRelease(this.release).then(response => {
        this.release = response.data
        this.submitting = false;
        iziToast.success({
          title: "OK",
          message: "Veröffentlichung gespeichert!",
          timeout: 3000,
          position: "topRight",
          transitionIn: "fadeInLeft"
        });

        this.formErrors = {}

        if (this.closeAfterSave) {
          this.$router.replace({ name: "press" });
          return;
        }

        if(!this.releaseId) {
        this.$router.replace({ name: 'press-edit', params:{id: response.data.id}});
          return;
        }

      }).catch(error => {
        this.submitting = false
        this.formErrors = error.response.data.errors
      });
    },
    storeAndClose() {
      this.closeAfterSave = true;
      this.store();
    },
    onImageSelected(image) {
      this.release.data.image.src = image;
    },
    onLogoSelected(image) {
      this.release.data.logo.src = image;
    },
    onImageRemoved() {
      this.release.data.image.src = ''
    },
    onLogoRemoved() {
      this.release.data.logo.src = ''
    }
  }
};
</script>
<style lang="scss" scoped>
.uk-button-default {
  background-color: #fff;
  &:hover {
    box-shadow: 0 0 0 1px rgba(197, 197, 197, 0.85),
      0 2px 5px 0 rgba(197, 197, 197, 0.85), 0 1px 1.5px 0 rgba(0, 0, 0, 0.07),
      0 1px 2px 0 rgba(0, 0, 0, 0.08);
  }
}
.uk-button-small {
  border-radius: 3px;
  padding: 3px 14px;
  font-size: 1rem;
  text-transform: none;
  &.muted {
    color: #999;
  }
}
.button-shadow {
    box-shadow: 0 0 0 1px rgba(43,45,80,.1), 0 2px 5px 0 rgba(43,45,80,.08), 0 1px 1.5px 0 rgba(0,0,0,.07), 0 1px 2px 0 rgba(0,0,0,.08);
    border: none;
}
</style>